import { useEffect } from "react";
import TagManager from "react-gtm-module";
import ReactGA from "react-ga4";
import { constant } from "@app/utils/constant";

function AnalyticsConsent() {
  useEffect(() => {
    let gaInitialized = false; 
    const getCookieScriptConsent = () => {
      const cookie = document.cookie
        .split("; ")
        .find(row => row.startsWith("CookieScriptConsent="));
      if (!cookie) return null;
      try {
        return JSON.parse(decodeURIComponent(cookie.split("=")[1]));
      } catch (e) {
        return null;
      } 
    }; 
    const initGA = () => {
      if (constant.GOOGLE_ANALYTICS && !gaInitialized) {
        TagManager.initialize({ gtmId: constant.GOOGLE_TAGMANAGER_KEY });
        ReactGA.initialize(constant.GOOGLE_ANALYTICS_KEY);
        gaInitialized = true; 
      }
    }; 
   const stopFacebookPixel = () => {
        if (window.fbq) {
          window.fbq('consent', 'revoke');
          window.fbq('consent', 'update', {
            ad_storage: 'denied',
            analytics_storage: 'denied',
          }); 
          const fbScript = document.querySelector('script[src*="fbevents.js"]');
          if (fbScript) fbScript.remove(); 
          console.log("Facebook Pixel stopped");
        } 
    }; 
    const stopGA = () => {
      if (gaInitialized && window.gtag) {
        window.gtag("consent", "update", { analytics_storage: "denied" }); 
      }
      gaInitialized = false;
    }; 
    // ---- Check consent and act accordingly ----
    const consent = getCookieScriptConsent();  
    if (consent?.action === "accept") {
      initGA(); 
    } else if (consent?.action === "reject") {
      stopGA(); 
      stopFacebookPixel();
    } else {
      console.log("No consent action found — waiting for user input");
    } 
    // ---- Listen to changes in consent ----
    const handleAccept = () => initGA();
    const handleReject = () => stopGA();

    window.addEventListener("CookieScriptAcceptAll", handleAccept);
    window.addEventListener("CookieScriptRejectAll", handleReject);

    return () => {
      window.removeEventListener("CookieScriptAcceptAll", handleAccept);
      window.removeEventListener("CookieScriptRejectAll", handleReject);
    };
  }, []);

  return null;
}

export default AnalyticsConsent;
